import { useAsync } from '../utils/hooks/useAsync.js';
import { useEffect, useMemo } from 'react';
import { Global } from '@emotion/react';
import { shadowSelector } from './GigerProvider/useTheme.js';
import { jsx } from '@emotion/react/jsx-runtime';

const interpolateUrl = (cdnUrl, urls) => urls.map(url => `url(${url.replace('$cdnUrl', cdnUrl)})`).join(', ');
async function loadFont(family, source, descriptors) {
  const font = new FontFace(family, source, descriptors);
  // wait for font to be loaded
  await font.load();
  // add font to document
  document.fonts.add(font);
}
const loadFontFaces = (fontFaces, cdnUrl) => {
  return Promise.all(fontFaces.map(_ref => {
    let {
      family,
      source,
      descriptors
    } = _ref;
    return loadFont(family, interpolateUrl(cdnUrl, source), descriptors);
  }));
};
const THEME_LOADED_CLASS = 'theme-loaded';
const FontsLoader = _ref2 => {
  let {
    cdnUrl,
    theme,
    reference,
    scope,
    emotionCacheShadowRootContainer
  } = _ref2;
  const {
    loading,
    error
  } = useAsync(() => loadFontFaces(theme.fontFaces || [], cdnUrl), [theme, cdnUrl]);
  const fontScope = scope || THEME_LOADED_CLASS;
  useEffect(() => {
    const parentHtmlElement = reference || document.body;
    if (!loading && !error) {
      parentHtmlElement.classList.add(THEME_LOADED_CLASS);
    } else {
      parentHtmlElement.classList.remove(THEME_LOADED_CLASS);
    }
  }, [error, loading, reference]);
  const styles = useMemo(() => {
    return {
      [emotionCacheShadowRootContainer ? shadowSelector : `.${fontScope}`]: {
        fontFamily: theme.defaultFontFamily || 'arial'
      }
    };
  }, [fontScope, theme.defaultFontFamily, emotionCacheShadowRootContainer]);
  return jsx(Global, {
    styles: styles
  });
};

export { FontsLoader };
//# sourceMappingURL=FontsLoader.js.map
